var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVlBetaLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 39,
    viewBox: "0 0 38 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2991 2.33449L9.55692 0H0L4.22318 12.2937L10.2991 2.33449Z",
    fill: "#FF4500"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.388 0H27.8833L23.9521 12.2937L34.6842 7.87084L37.388 0Z",
    fill: "#A4C217"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6838 7.87084L27.8828 0H37.3875L34.6838 7.87084Z",
    fill: "#D5CA29"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4816 12.2941L10.2989 2.33496L6.08301 9.24494L13.4816 12.2941Z",
    fill: "#D6493E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.3777 27.3006L18.6937 28.7375L13.4815 12.2939L7.14746 20.8086L9.3777 27.3006Z",
    fill: "#A63B94"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6943 28.7375L28.0089 27.3047L30.3683 20.4362L23.9525 12.2939L18.6943 28.7375Z",
    fill: "#2DB686"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6941 28.7373L24.3129 38.0628H13.0752L18.6941 28.7373Z",
    fill: "#0197D8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6939 28.7368L13.075 38.0623L9.37793 27.2998L18.6939 28.7368Z",
    fill: "#336C9B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3132 38.063L28.0088 27.3047L18.6943 28.7375L24.3132 38.063Z",
    fill: "#26BF79"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M7.14801 20.8084L13.4821 12.2937L2.69629 7.84863L7.14801 20.8084Z",
    fill: "#CC4E84"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M30.368 20.4362L23.9521 12.2939L34.6842 7.87109L30.368 20.4362Z",
    fill: "#1BC07D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVlBetaLogo);
export default __webpack_public_path__ + "static/media/VL-Beta-Logo.5cbe251057c228efe91f6281353393d1.svg";
export { ForwardRef as ReactComponent };